import React, { FC, useEffect, useRef, useState } from 'react';

import { AnswerTypes } from 'types';

import { ReactComponent as Star } from 'assets/images/star.svg';
import ProgressBar from 'components/ProgressBar';
import Header from 'components/Header';

const LoadScreen: FC<AnswerTypes> = (props) => {
    const { title, answers, image, logoUrl, logoLink, handleSwitchToNextScreen, id } = props;
    const [progress, setProgress] = useState(0);
    const answerObj = useRef<Record<number, string>>({});

    useEffect(() => {
        if (answers) {
            answers.forEach((item, index) => {
                const present = 100 / answers.length;

                answerObj.current[Number(present * (index + 1))] = item;
            });
        }
    }, []);

    useEffect(() => {
        let interval: ReturnType<typeof setInterval>;
        const startAnimate = (delay: number, toValue: number): void => {
            interval = setInterval(() => {
                setProgress((prevProgress) => {
                    if (prevProgress < toValue) return prevProgress + 1;

                    clearInterval(interval);
                    return prevProgress;
                });
            }, delay);
        };

        startAnimate(50, 100);

        if (progress === 100) {
            handleSwitchToNextScreen();
        }

        return () => clearInterval(interval);
    }, [progress]);

    const getWordFromTimer = (timerValue: number) => {
        const closestKey = Object.keys(answerObj.current)
            .sort((a, b) => Number(a) - Number(b))
            .find((key) => Number(key) > timerValue);

        if (closestKey) {
            return answerObj.current?.[Number(closestKey)];
        }

        return null;
    };

    return (
        <section className="load">
            <Header logoUrl={logoUrl} isHiddenProgress logoLink={logoLink} />
            <div className="load__wrapper" style={{ backgroundImage: `url(${image}` }}>
                <Star className="load__star" />
                {title && <h2 dangerouslySetInnerHTML={{ __html: title }} className="load__title" />}
                {answers && <p className="load__text">{getWordFromTimer(progress)}</p>}
                <div className="load__inner-wrap">
                    <p className="load__procent">{progress}%</p>
                    <div className="load__progress-wrap">
                        <ProgressBar total={100} activeScreen={progress} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LoadScreen;
